import { render, staticRenderFns } from "./ClassificationOfGoods.vue?vue&type=template&id=ccfcb010&scoped=true&"
import script from "./ClassificationOfGoods.vue?vue&type=script&lang=js&"
export * from "./ClassificationOfGoods.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationOfGoods.vue?vue&type=style&index=0&id=ccfcb010&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccfcb010",
  null
  
)

export default component.exports